/*
 * Copyright © 2021-present Tacnode Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Tacnode Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Tacnode Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { TableColumnsType } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ModelFrozen } from 'account-client'
import { useTranslateAmount } from '@/hooks/useTranslateAmount'
import { useTranslateEnum } from '@/hooks/useTranslateEnum'
import { FrozenType } from '@/pages/billing/interface'
import { timeFormatter } from '@/utils/timeFormatter'

export function useFrozenDetailsColumns() {
  const { t } = useTranslation()
  const { translate } = useTranslateEnum()
  const { currency } = useTranslateAmount()

  const columns = useMemo<TableColumnsType<ModelFrozen>>(() => {
    return [
      {
        title: t('Traded on'),
        dataIndex: 'gmtTime',
        sorter: true,
        width: 160,
        render: value => timeFormatter.format(value),
      },
      {
        title: `${t('Frozen Total Amount')}（${currency}）`,
        dataIndex: 'newBalanceFormatted',
        width: 130,
      },
      {
        title: t('Type'),
        dataIndex: 'type',
        width: 100,
        render: value => translate(value),
      },
      {
        title: `${t('Frozen Amount')}（${currency}）`,
        dataIndex: 'type',
        render: (value, record) => (value === FrozenType.frozen ? record.amountFormatted : '-'),
      },
      {
        title: `${t('Unfrozen Amount')}（${currency}）`,
        dataIndex: 'type',
        render: (value, record) => (value === FrozenType.unfrozen ? record.amountFormatted : '-'),
      },
    ]
  }, [])

  return columns
}
